import styled from 'styled-components'

import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'

export const Title = styled.div`
  font-size: 34px;
  margin: 16px 0 40px 0;
  font-family: Circular-Std-Bold;
`

export const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 450;
  margin: 24px 0;
  color: ${colors.strongGray};
`

export const AreaLabel = styled.div`
  font-size: 12px;
  color: ${colors.strongGray};
  font-size: 15px;
`

export const ModalContainer = Modal.styled`
  background-color: ${colors.titleStrongWhite};
  padding: 24px 24px 40px 24px;
  border-radius: 12px;
  overflow-y: auto; /* Adiciona barra de rolagem vertical */
`

export const ModalBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`
